import http from 'axios';
import get from 'lodash/get';

import { toastr } from '../components/CustomToast';
import { getCurrentSession } from '../helpers/auth';

const REGION = process.env.REACT_APP_REGION;

const CLIENT_IDS = {
  solar: process.env.REACT_APP_SOLAR_APP_CLIENT_ID,
  demand: process.env.REACT_APP_DEMAND_APP_CLIENT_ID,
};
const WEB_API_IDS = {
  solar: process.env.REACT_APP_SOLAR_WEB_API_ID,
  demand: process.env.REACT_APP_DEMAND_WEB_API_ID,
};

export const errorResponseToastr = (err) => {
  toastr.error({
    title: 'Error',
    message: get(err, 'response.data.reason', 'An Error Occured'),
  });
};
export default class WebAPIClient {
  constructor(appId) {
    this.appId = appId;

    this.axios = http.create({
      baseURL: `https://${WEB_API_IDS[appId]}.execute-api.${REGION}.amazonaws.com/v1/web`,
      timeout: 20000,
      headers: {
        'Content-Type': 'application/json',
      },
    });
    this.axios.interceptors.request.use(async function (config) {
      const { accessToken } = await getCurrentSession(CLIENT_IDS[appId], appId);
      if (accessToken) {
        config.headers.Authorization = accessToken;
      }
      return config;
    });
  }

  async GET(endpoint = '', params = {}) {
    return this._handleResponse(await this.axios.get(endpoint, { params }));
  }

  async POST(endpoint = '', data = {}) {
    return this._handleResponse(await this.axios.post(endpoint, data));
  }

  async PUT(endpoint = '', data = {}) {
    return this._handleResponse(await this.axios.put(endpoint, data));
  }

  async DELETE(endpoint = '') {
    return this._handleResponse(await this.axios.delete(endpoint));
  }

  _handleResponse(response) {
    if (response?.data?.result === 'success') {
      return response?.data?.value;
    }
  }
}
